<template>
  <div class="project new-project" v-bind:class="{'project-form': showDialog}">
    <div v-if="!showDialog" v-on:click="displayDialog">
      <div class="plus-sign">+</div>
      <div>Add Project</div>
    </div>

    <div v-if="showDialog" class="dialog">
      <div class="card">
        <h1>Add Project</h1>
        <ProjectForm v-on:hide-dialog="cancelDialog" v-on:save-project="saveProject" />
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import ProjectForm from '@/components/project/ProjectForm.vue'

export default {
  name: 'NewProject',
  components: { ProjectForm },
  data() {
    return {
      showDialog: false,
      name: '',
      colour: '',
      isActive: false
    }
  },
  methods: {
    displayDialog() {
      this.showDialog = true
    },
    hideDialog() {
      this.showDialog = false
    },
    cancelDialog() {
      this.initForm()
    },
    saveProject(project) {
      this.makeSureHexValueHasNumberSign();
      firebase.database().ref('projects').push(project)
        .then(() => this.initForm())
    },
    makeSureHexValueHasNumberSign() {
      if (!this.colour.startsWith('#')) {
        this.colour = `#${this.colour}`
      }
    },
    initForm() {
      this.name = ''
      this.colour = ''
      this.hideDialog()
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/input';
@import '../../assets/styles/dialog';
@import '../../assets/styles/card';

.new-project:not(.project-form) {
  width: 100%;
  height: 142px;
  border: 2px dashed $primary-shadow;
  box-shadow: none;
  background: transparent;
  cursor: default;

  @media (min-width: 450px) {
    width: 196px;
  }

  div {
    color: $primary-shadow;
    font-size: 13px;
  }

  .plus-sign {
    font-size: 40px;
  }

  div:first-child {
    cursor: pointer;
  }
}

.project-form {
  height: 144px;
  box-sizing: border-box;
  border-color: transparent;
  padding: 0 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/project/NewProject.vue